export default "__VITE_ASSET__DT0uYKcC__"